import boilerToken from "../abis/production/tokens/boilerToken";

export default {
  name: "BOILER",
  abi: boilerToken.abi,
  contractAddress: "0xfD1dD9F98F5f5625ce243B1E817cbFa0594AbAeA",
  decimals: 18,
};
